import { Plus, X, Package } from "@phosphor-icons/react";
import { formatRupiah } from "../lib/format";

/** Editable list of user-defined extra costs per tindakan (implant, sewa alat lain, dsb). */
export default function BiayaTambahanEditor({ index, items = [], onChange }) {
  const update = (i, patch) => {
    const next = items.map((it, k) => (k === i ? { ...it, ...patch } : it));
    onChange(next);
  };
  const remove = (i) => onChange(items.filter((_, k) => k !== i));
  const add = () => onChange([...items, { nama: "", nominal: 0 }]);
  const total = items.reduce((s, it) => s + (Number(it.nominal) || 0), 0);

  return (
    <div
      className="mt-4 pt-4 border-t border-slate-100"
      data-testid={`biaya-tambahan-section-${index + 1}`}
    >
      <div className="flex items-center justify-between flex-wrap gap-2 mb-2">
        <div>
          <div className="text-xs font-bold uppercase tracking-wide text-slate-600 flex items-center gap-1.5">
            <Package size={14} weight="duotone" /> Biaya Tambahan Lainnya
          </div>
          <div className="text-[11px] text-slate-500">
            Implant, sewa alat lain, BHP khusus, dsb. Muncul sebagai baris terpisah di
            estimasi &amp; kop surat.
          </div>
        </div>
        <button
          type="button"
          onClick={add}
          className="inline-flex items-center gap-1 text-xs font-bold text-[#0A3F9A] border border-[#0A3F9A] px-3 py-1.5 rounded hover:bg-blue-50 transition-colors"
          data-testid={`btn-add-biaya-${index + 1}`}
        >
          <Plus size={12} weight="bold" /> Tambah Field
        </button>
      </div>

      {items.length > 0 && (
        <div className="flex flex-col gap-2" data-testid={`biaya-tambahan-list-${index + 1}`}>
          {items.map((it, i) => (
            <div
              key={i}
              className="grid grid-cols-[1fr_160px_32px] gap-2 items-center"
              data-testid={`biaya-row-${index + 1}-${i}`}
            >
              <input
                type="text"
                value={it.nama}
                onChange={(e) => update(i, { nama: e.target.value })}
                placeholder="Nama biaya, mis. Implant Plate & Screw"
                className="w-full bg-white border border-slate-300 text-slate-900 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-[#0A3F9A]"
                data-testid={`input-biaya-nama-${index + 1}-${i}`}
              />
              <input
                type="number"
                min={0}
                step={50000}
                value={it.nominal ?? 0}
                onChange={(e) => update(i, { nominal: Number(e.target.value) || 0 })}
                placeholder="Rp"
                className="w-full bg-white border border-slate-300 text-slate-900 rounded px-3 py-2 text-sm tabular-nums text-right focus:ring-2 focus:ring-[#0A3F9A]"
                data-testid={`input-biaya-nominal-${index + 1}-${i}`}
              />
              <button
                type="button"
                onClick={() => remove(i)}
                className="h-8 w-8 flex items-center justify-center text-slate-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
                title="Hapus"
                data-testid={`btn-remove-biaya-${index + 1}-${i}`}
              >
                <X size={14} weight="bold" />
              </button>
            </div>
          ))}
          <div className="text-xs text-right text-slate-600">
            Total biaya tambahan:{" "}
            <span className="font-bold tabular-nums text-slate-900" data-testid={`biaya-tambahan-total-${index + 1}`}>
              {formatRupiah(total)}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
